<template>
    <div class="bg-gray-100/30 dark:bg-gray-900 w-full min-h-[1rem] dark:border-b dark:border-b-gray-750">
        <slot />
    </div>
</template>